/**
 * Builds an enhanced Linkout URL with tracking parameters
 */
export const buildEnhancedUrl = (
  originalUrl: string,
  idToken: string,
  correlationId: string,
  helid: string,
  trackingContext?: any
): string => {
  if (!idToken) {
    throw new Error('idToken is required');
  }
  const url = new URL(originalUrl);
  url.searchParams.append('idToken', idToken);
  url.searchParams.append('correlationId', correlationId);
  url.searchParams.append('helid', helid);

  if (trackingContext) {
    url.searchParams.append('trackingContext', JSON.stringify(trackingContext));
  }

  return url.href;
};
